export default "__VITE_ASSET__BV0ixCZG__"